import VerifyPhoneStepTwo from './VerifyPhoneStepTwo'

export default VerifyPhoneStepTwo
